module.exports = __webpack_public_path__ + "static/media/brochure.01728a8a.pdf";